export * from "./colorconstants";
export const BreakpointLabels = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
];
export const Breakpoints = {
    xs: { min: 0, max: 543.99 },
    sm: { min: 544, max: 767.99 },
    md: { min: 768, max: 991.99 },
    lg: { min: 992, max: 1199.99 },
    xl: { min: 1200, max: Infinity },
};
export const revoBreakpoints = {
    mobilePortrait: { min: 0, max: 479.99 },
    mobileLandscape: { min: 480, max: 767.99 },
    tabletPortrait: { min: 768, max: 1023.99 },
    tabletLandscape: { min: 1024, max: 1368.99 },
    desktopSmall: { min: 1369, max: 1679 },
    desktopWide: { min: 1370, max: Infinity },
};
export const sortedRevoBreakpoints = Object.keys(revoBreakpoints).sort((keyA, keyB) => revoBreakpoints[keyA].min - revoBreakpoints[keyB].min);
export const flexAlignMapping = {
    center: "center",
    spaceBetween: "space-between",
    end: "flex-end",
    start: "flex-start",
};
export const flexDirectionMapping = {
    col: "column",
    "col-reverse": "column-reverse",
    row: "row",
    "row-reverse": "row-reverse",
};
export function isResponsiveSpec(spec) {
    const hokus = spec;
    return (typeof spec === "object" &&
        !!(hokus.desktopWide ||
            hokus.desktopSmall ||
            hokus.mobilePortrait ||
            hokus.mobileLandscape ||
            hokus.tabletLandscape ||
            hokus.tabletPortrait));
}
export function mapBreakpoint(f, spec) {
    return Object.keys(spec)
        .sort((keyA, keyB) => revoBreakpoints[keyA].min - revoBreakpoints[keyB].min)
        .map((key) => f(spec[key], [key, revoBreakpoints[key]]));
}
export function revoSizeToPadding(size) {
    if (Array.isArray(size)) {
        return {
            padding: `${size.join("px ")}px`,
        };
    }
    else {
        return {
            padding: `${size}px`,
        };
    }
}
//# sourceMappingURL=layoutconstants.js.map